import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { Modal, Typography, Link, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import dynamic from "next/dynamic";
import React, { useState } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "487px",
    background: "#242033",
    borderRadius: "10px",
    color: "white",
    padding:"50px",
    '@media(max-width:480px)':{
      padding:"15px",
    },
  },
  paper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    padding: "10px",
  },
  popupTitle:{
    padding: "17px 0px", 
    borderBottom: "0.5px solid rgba(255, 255, 255, 0.5)",
    '& p':{
      fontSize:"12px",
    },
  },
  popupDescription:{
    padding: "17px 0px", 
    borderBottom: "0.5px solid rgba(255, 255, 255, 0.5)",
    '& p':{
      fontSize:"10px",
      marginBottom:"10px"
    },
  },
  popupDescription2:{
    padding: "17px 0px", 
    '& p':{
      fontSize:"10px",
      marginBottom:"10px",
      fontWeight:"400"
    },
  },
  identityAvatar:{
    position:"relative",
    display:"flex",
    justifyContent:"start",
    alignItems:"center",
    padding:"15px 0",
    borderBottom: "0.5px solid rgba(255, 255, 255, 0.5)",
  },
  nameStatus:{
    position:"relative",
    display:"block",
    padding:"0 15px",
    lineHeight: "7px",
    '& p':{
      fontSize:"14px",
      fontWeight:"400"
    },
    '& small':{
      position:"relative",
      display:"inline-block",
      fontSize:"9px",
      fontWeight:"400",
      color:"#F10C83",
    },
  },
  gradText: {
    position:"relative",
    display:"block",
    width:"100%",
    maxWidth:"125px",
    background:"transparent",
    color:"#fff",
    fontSize:"10px",
    borderRadius:"7px",
    height:"37px",
    border:"1px solid #ccc",
    marginRight:"10px",
    fontWeight:"400"
  },
  btn: {
    width: "100%",
    borderRadius: "7px",
    background:"linear-gradient(90deg, #F30B81 0%, #4330FF 52.6%, #2CACC6 100%)",
    color:"#fff",
    fontSize:"10px",
    fontWeight:"400",
    textTransform:"capitalize",
    height: "37px",
    cursor: "pointer",
    position:"relative",
    display:"block",
    border:"none"
  },
  flex: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position:"relatibve",
    padding:"16px 0"
  },
  knowMoreProcess:{
    display:"block",
    textAlign:"center",
    fontSize:"9px",
    marginTop:"18px",
    '& a':{
      color:"#fff",
      textDecortion:"underline"
    },
  },
  txtField:{
    marginTop: "10px",
    fontSize: "10px",
    fontWeight: "400",
    color:"#ccc",
    width: "100%",
    padding:"0 15px",
    height: "38px",
    borderRadius: "7px",
    background:"transparent",
    border:"1px solid #ccc",
  },
}));

const IdentityModal = ({ openModal, handleModalClose }) => {
    const classes = useStyles();
    const [open, setOpen] = useState(true); 
    const handleClose = () => setOpen(false);

  return (
    <>
      <Modal open={openModal} onClose={handleModalClose}>
        <div className={classes.root}>
            <div className={classes.paper}>
              <div className={classes.popupTitle} >
                <Typography component="p">Complete your identity check to add funds</Typography>
              </div>
              <div className={classes.popupDescription} >
                <Typography component="p">If you want to add more than $3,000 in a day or more than $10,000 over the
                lifetime of the account, we need to verify your identity.</Typography>

                <Typography component="p">Exception: In India, account limits are INR 10,000. If you exceed this limit during
                the lifetime of the account, you are required to complete the identity check.</Typography>

                <Typography component="p">This information is intended o keep our community safe and create a stronger
                experience for you. It will not be shared for marketing purposes. Only you can
                see your personal information. </Typography>
              </div>
              <div className={classes.identityAvatar}>
                <Box component="img" src="/images/profile/profile-pic.png" width="42px" height="42px"></Box>
                <div className={classes.nameStatus}>
                  <Typography component="p">Identity Check Status</Typography>
                  <Typography component="small">Failed</Typography>
                </div>
              </div>
              <div className={classes.flex}>
                <button type="button" onClick={handleClose} className={classes.gradText}> Back </button>
                <button type="submit" className={classes.btn}> Start Identity Check </button>
              </div>
              <div className={classes.knowMoreProcess}>
                <Link href="#">Learn more about this process</Link>
              </div>
            </div>
        </div>
      </Modal>
    </>
  );
};

export default IdentityModal;